var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7572_717)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 39.5,
    r: 17.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0002 33.167H40.8335C41.1429 33.167 41.4397 33.2899 41.6585 33.5087C41.8772 33.7275 42.0002 34.0242 42.0002 34.3337C42.0002 34.6431 41.8772 34.9398 41.6585 35.1586C41.4397 35.3774 41.1429 35.5003 40.8335 35.5003H35.0002C34.6907 35.5003 34.394 35.3774 34.1752 35.1586C33.9564 34.9398 33.8335 34.6431 33.8335 34.3337C33.8335 34.0242 33.9564 33.7275 34.1752 33.5087C34.394 33.2899 34.6907 33.167 35.0002 33.167ZM43.1668 42.5003H49.0002C49.3096 42.5003 49.6063 42.6232 49.8251 42.842C50.0439 43.0608 50.1668 43.3576 50.1668 43.667C50.1668 43.9764 50.0439 44.2732 49.8251 44.492C49.6063 44.7107 49.3096 44.8337 49.0002 44.8337H43.1668C42.8574 44.8337 42.5607 44.7107 42.3419 44.492C42.1231 44.2732 42.0002 43.9764 42.0002 43.667C42.0002 43.3576 42.1231 43.0608 42.3419 42.842C42.5607 42.6232 42.8574 42.5003 43.1668 42.5003ZM35.0002 37.8337H49.0002C49.3096 37.8337 49.6063 37.9566 49.8251 38.1754C50.0439 38.3942 50.1668 38.6909 50.1668 39.0003C50.1668 39.3097 50.0439 39.6065 49.8251 39.8253C49.6063 40.0441 49.3096 40.167 49.0002 40.167H35.0002C34.6907 40.167 34.394 40.0441 34.1752 39.8253C33.9564 39.6065 33.8335 39.3097 33.8335 39.0003C33.8335 38.6909 33.9564 38.3942 34.1752 38.1754C34.394 37.9566 34.6907 37.8337 35.0002 37.8337Z",
    fill: "#F7C948"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7572_717",
    x: 0.9,
    y: 0.9,
    width: 81.2,
    height: 81.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_7572_717"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7572_717"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7572_717",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menuIcon.2611b040fe590d38c9259d90cbfac778.svg";
export { ForwardRef as ReactComponent };